import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {MedicalRecordGeneralInformationModel} from '../../../api/model/medicalRecordGeneralInformation.model';
import {
    MedicalRecordGeneralInformationConverter
} from '../../../api/converter/medicalRecordGeneralInformation.converter';

@Injectable({providedIn: 'root'})
export class MedicalRecordGeneralInformationDataService
    extends AbstractDataServiceV2<MedicalRecordGeneralInformationModel, MedicalRecordGeneralInformationConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: MedicalRecordGeneralInformationConverter) {
        super('MedicalRecordGeneralInformation', http, httpUrlGenerator, logger, config, converter);
    }
}
